// extracted by mini-css-extract-plugin
export default {"wrapper":"template_wrapper__w97Ku","slider":"template_slider__4r+5w","table":"template_table__-5KZH"};